<template>
  <div>
    <header-bar>
      {{ type === 'album' ? 'アルバム（2曲以上）': 'シングル' }}配信
    </header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">リリース情報登録</h3>
        <release-type-label :type="type" />
      </div>
      <release-information
        :confirm-product-errors="{}"
        @stateDetected="setState" />
      <release-distribution
        v-if="status!==0"
        :readonly="true" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../../HeaderBar'
import ReleaseTypeLabel from '../ReleaseTypeLabel'
import ReleaseInformation from './ReleaseInformation'
import ReleaseDistribution from '../Step3/ReleaseDistribution'

export default {
  name: 'ReleaseStep2',
  components: {
    ReleaseInformation,
    ReleaseTypeLabel,
    HeaderBar,
    ReleaseDistribution,
  },
  filters: {
    join(array, separator) {
      return array.join(separator)
    },
    boolToStr(value) {
      return value ? 'YES' : 'NO'
    },
    toReleasedType: (value) => (parseInt(value, 10) === 1 ? 'あり' : 'なし'),
  },
  data() {
    return {
      status: 2,
      type: '',
    }
  },
  computed: {
    ...mapGetters('auth', ['subscriptionDefaulted']),
  },
  methods: {
    setState(value) {
      this.status = value.status
      this.type = value.type
    },
  },
}
</script>
